import { paymentsMatchingConstants } from "./paymentsMatching.constants";

export function paymentsMatching(state = {}, action) {
    switch (action.type) {
        case paymentsMatchingConstants.GET_ACTIVE_AND_INACTIVE_ORGANIZATIONS_REQUEST:
            return {
                ...state,
                submitted: true,
                loading: true,
                errorMessage: null,
            };

        case paymentsMatchingConstants.GET_ACTIVE_AND_INACTIVE_ORGANIZATIONS_SUCCESS:
            return {
                ...state,
                submitted: false,
                loading: false,
                activatedOrganizations: action.result.activeOrganizations,
                inActivatedOrganizations: action.result.inactiveOrganizations,
                errorMessage: null,
            };

        case paymentsMatchingConstants.GET_ACTIVE_AND_INACTIVE_ORGANIZATIONS_FAILURE:
            return {
                ...state,
                submitted: false,
                loading: false,
                errorMessage: action.errorMessage,
            };

        case paymentsMatchingConstants.ACTIVATE_PAYMENTS_MATCHING_BY_ORGANIZATION_REQUEST:
            return {
                ...state,
                submitted: true,
                loading: true,
                errorMessage: null,
            };

        case paymentsMatchingConstants.ACTIVATE_PAYMENTS_MATCHING_BY_ORGANIZATION_SUCCESS:
            return {
                ...state,
                submitted: false,
                loading: false,
                errorMessage: null,
                successMessage: action.result,
            };

        case paymentsMatchingConstants.ACTIVATE_PAYMENTS_MATCHING_BY_ORGANIZATION_FAILURE:
            return {
                ...state,
                submitted: false,
                loading: false,
                errorMessage: action.errorMessage,
            };

        case paymentsMatchingConstants.REACTIVATE_PAYMENTS_MATCHING_BY_ORGANIZATION_REQUEST:
            return {
                ...state,
                submitted: true,
                loading: true,
                errorMessage: null,
            };

        case paymentsMatchingConstants.REACTIVATE_PAYMENTS_MATCHING_BY_ORGANIZATION_SUCCESS:
            return {
                ...state,
                submitted: false,
                loading: false,
                errorMessage: null,
                successMessage: action.result,
            };

        case paymentsMatchingConstants.REACTIVATE_PAYMENTS_MATCHING_BY_ORGANIZATION_FAILURE:
            return {
                ...state,
                submitted: false,
                loading: false,
                errorMessage: action.errorMessage,
            };

        case paymentsMatchingConstants.DEACTIVATE_PAYMENTS_MATCHING_BY_ORGANIZATION_REQUEST:
            return {
                ...state,
                submitted: true,
                loading: true,
                errorMessage: null,
            };

        case paymentsMatchingConstants.DEACTIVATE_PAYMENTS_MATCHING_BY_ORGANIZATION_SUCCESS:
            return {
                ...state,
                submitted: false,
                loading: false,
                errorMessage: null,
                successMessage: action.result,
            };

        case paymentsMatchingConstants.DEACTIVATE_PAYMENTS_MATCHING_BY_ORGANIZATION_FAILURE:
            return {
                ...state,
                submitted: false,
                loading: false,
                errorMessage: action.errorMessage,
            };

        default:
            return state;
    }
}
